import { render, staticRenderFns } from "./DomainTreeLockChild.vue?vue&type=template&id=08b19236&"
import script from "./DomainTreeLockChild.vue?vue&type=script&lang=js&"
export * from "./DomainTreeLockChild.vue?vue&type=script&lang=js&"
import style0 from "./DomainTreeLockChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports